import React, { useState, useEffect } from 'react';
import { getAllPublicContent } from '../services/api';

const DynamicAbout = () => {
  const [content, setContent] = useState({
    whoWeAre: null,
    vision: null,
    mission: null
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAllContent();
  }, []);

  const fetchAllContent = async () => {
    try {
      const response = await getAllPublicContent();
      
      console.log('All Content Response:', response);
      
      if (response && response.data && Array.isArray(response.data)) {
        const allContent = response.data;
        
        const whoWeAreData = allContent.find(item => item.sectionId === 'about');
        const visionData = allContent.find(item => item.sectionId === 'vision');
        const missionData = allContent.find(item => item.sectionId === 'mission');
        
        console.log('Who We Are Data:', whoWeAreData);
        console.log('Vision Data:', visionData);
        console.log('Mission Data:', missionData);
        
        setContent({
          whoWeAre: whoWeAreData || null,
          vision: visionData || null,
          mission: missionData || null
        });
      } else if (response && response.data) {
        setContent({
          whoWeAre: response.data.about || null,
          vision: response.data.vision || null,
          mission: response.data.mission || null
        });
      }
    } catch (error) {
      console.error('Error fetching about content:', error);
    } finally {
      setLoading(false);
    }
  };

  // Function to render mission content with proper alignment
  const renderMissionContent = (missionContent) => {
    if (!missionContent) {
      return (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'left' }}>
          <li style={{ 
            padding: '0.75rem 0', 
            display: 'flex', 
            alignItems: 'center', 
            gap: '0.75rem', 
            borderBottom: '1px solid #F0F2F5',
            textAlign: 'left'
          }}>
            <i className="fas fa-check-circle" style={{ color: '#2C7A7B', fontSize: '1rem', flexShrink: 0 }}></i>
            <span>Deliver enterprise-grade software and consulting</span>
          </li>
          <li style={{ 
            padding: '0.75rem 0', 
            display: 'flex', 
            alignItems: 'center', 
            gap: '0.75rem', 
            borderBottom: '1px solid #F0F2F5',
            textAlign: 'left'
          }}>
            <i className="fas fa-check-circle" style={{ color: '#2C7A7B', fontSize: '1rem', flexShrink: 0 }}></i>
            <span>Build future-ready AI & simulation ecosystems</span>
          </li>
          <li style={{ 
            padding: '0.75rem 0', 
            display: 'flex', 
            alignItems: 'center', 
            gap: '0.75rem', 
            borderBottom: '1px solid #F0F2F5',
            textAlign: 'left'
          }}>
            <i className="fas fa-check-circle" style={{ color: '#2C7A7B', fontSize: '1rem', flexShrink: 0 }}></i>
            <span>Empower MSMEs through Lean certification and technology integration</span>
          </li>
          <li style={{ 
            padding: '0.75rem 0', 
            display: 'flex', 
            alignItems: 'center', 
            gap: '0.75rem',
            textAlign: 'left'
          }}>
            <i className="fas fa-check-circle" style={{ color: '#2C7A7B', fontSize: '1rem', flexShrink: 0 }}></i>
            <span>Drive innovation through continuous learning and research</span>
          </li>
        </ul>
      );
    }
    
    // If content has bullet points with • character, convert to list items
    if (missionContent.includes('•')) {
      const lines = missionContent.split('\n').filter(line => line.trim());
      return (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'left' }}>
          {lines.map((line, index) => {
            const cleanLine = line.replace(/[•\-*]/g, '').trim();
            if (!cleanLine) return null;
            return (
              <li key={index} style={{ 
                padding: '0.75rem 0',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                borderBottom: index < lines.length - 1 ? '1px solid #F0F2F5' : 'none',
                textAlign: 'left'
              }}>
                <i className="fas fa-check-circle" style={{ color: '#2C7A7B', fontSize: '1rem', flexShrink: 0 }}></i>
                <span>{cleanLine}</span>
              </li>
            );
          })}
        </ul>
      );
    }
    
    // If content has new lines, render as paragraphs
    if (missionContent.includes('\n')) {
      const paragraphs = missionContent.split('\n').filter(p => p.trim());
      return (
        <div style={{ textAlign: 'left' }}>
          {paragraphs.map((para, index) => (
            <p key={index} style={{ 
              marginBottom: '0.75rem', 
              lineHeight: '1.7',
              color: '#5A6E7F',
              fontSize: 'clamp(0.9rem, 3.5vw, 1rem)'
            }}>
              {para.trim()}
            </p>
          ))}
        </div>
      );
    }
    
    // Default: render as text with proper alignment
    return (
      <div style={{ 
        textAlign: 'left', 
        lineHeight: '1.7',
        color: '#5A6E7F',
        fontSize: 'clamp(0.9rem, 3.5vw, 1rem)'
      }}>
        {missionContent}
      </div>
    );
  };

  if (loading) {
    return (
      <section style={{ padding: '5rem 0', textAlign: 'center' }}>
        <div className="container">
          <i className="fas fa-spinner fa-spin" style={{ fontSize: '2rem', color: '#2C7A7B' }}></i>
          <p style={{ marginTop: '1rem', color: '#5A6E7F' }}>Loading content...</p>
        </div>
      </section>
    );
  }

  const whoWeAre = content.whoWeAre;
  const vision = content.vision;
  const mission = content.mission;

  return (
    <>
      {/* Who We Are Section */}
      <section id="who-we-are" style={{ 
        padding: 'clamp(2rem, 6vw, 5rem) 0', 
        background: whoWeAre?.backgroundColor || '#FFFFFF'
      }}>
        <div className="container">
          <div style={{ 
            textAlign: 'center', 
            maxWidth: '900px', 
            margin: '0 auto',
            padding: '0 1rem'
          }}>
            <h2 style={{ 
              fontSize: 'clamp(1.6rem, 6vw, 2.5rem)', 
              marginBottom: '1rem', 
              color: '#0A192F',
              fontWeight: 700
            }}>
              {whoWeAre?.title || 'Who We Are'}
            </h2>
            <div style={{ 
              fontSize: 'clamp(0.9rem, 4vw, 1.125rem)', 
              color: '#2C7A7B', 
              marginBottom: '2rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              {whoWeAre?.subtitle || 'Engineering the Future, Delivering Excellence'}
            </div>
            
            <div style={{
              background: '#F7F9FC',
              padding: 'clamp(1.5rem, 5vw, 3rem)',
              borderRadius: '24px',
              textAlign: 'left'
            }}>
              <div 
                style={{ 
                  fontSize: 'clamp(0.95rem, 4vw, 1.1rem)', 
                  lineHeight: '1.7', 
                  color: '#1E293B'
                }}
                dangerouslySetInnerHTML={{ 
                  __html: whoWeAre?.content || '<strong>INTELIHEADS INTERNET Pvt. Ltd</strong> is a global technology company specialising in advanced power system software, engineering simulation, AI-driven modeling, and enterprise training solutions.<br/><br/>We bridge the gap between cutting-edge research and industrial application — helping utilities, manufacturers, and educational institutions accelerate innovation and operational resilience.'
                }}
              />
              {whoWeAre?.buttonText && (
                <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
                  <a 
                    href={whoWeAre.buttonLink || '#'}
                    style={{
                      display: 'inline-block',
                      padding: '0.8rem 2rem',
                      background: '#2C7A7B',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '40px',
                      fontWeight: 600,
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.background = '#236B6C'}
                    onMouseLeave={(e) => e.target.style.background = '#2C7A7B'}
                  >
                    {whoWeAre.buttonText} <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section with Vision & Mission */}
      <section id="about" style={{ 
        padding: 'clamp(2rem, 6vw, 5rem) 0', 
        background: '#F7F9FC'
      }}>
        <div className="container">
          <h2 style={{ 
            fontSize: 'clamp(1.6rem, 6vw, 2.5rem)', 
            marginBottom: '1rem', 
            color: '#0A192F', 
            textAlign: 'center',
            fontWeight: 700
          }}>
            About Us
          </h2>
          <div style={{ 
            fontSize: 'clamp(0.9rem, 4vw, 1.125rem)', 
            color: '#5A6E7F', 
            textAlign: 'center', 
            marginBottom: 'clamp(2rem, 5vw, 3rem)'
          }}>
            Driving Innovation in Power Systems & Engineering Simulation
          </div>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: 'clamp(1.5rem, 4vw, 2.5rem)',
            marginTop: '2rem'
          }}>
            {/* Vision Card */}
            <div style={{
              background: 'white',
              padding: 'clamp(1.5rem, 5vw, 2.5rem)',
              borderRadius: '24px',
              boxShadow: '0 10px 25px -5px rgba(0,0,0,0.05)',
              border: '1px solid #E2E8F0',
              transition: 'all 0.3s ease',
              height: '100%',
              display: 'flex',
              flexDirection: 'column'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.borderColor = '#2C7A7B';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = '#E2E8F0';
            }}>
              <div style={{
                width: 'clamp(60px, 12vw, 70px)',
                height: 'clamp(60px, 12vw, 70px)',
                background: 'linear-gradient(135deg, #2C7A7B 0%, #4A9D9E 100%)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem auto'
              }}>
                <i className="fas fa-eye" style={{ fontSize: 'clamp(1.5rem, 5vw, 2rem)', color: 'white' }}></i>
              </div>
              <h3 style={{ 
                fontSize: 'clamp(1.3rem, 5vw, 1.8rem)', 
                marginBottom: '1rem', 
                color: '#0A192F',
                fontWeight: 700,
                textAlign: 'center'
              }}>
                {vision?.title || 'Our Vision'}
              </h3>
              <p style={{ 
                color: '#5A6E7F', 
                lineHeight: '1.7',
                fontSize: 'clamp(0.9rem, 3.5vw, 1rem)',
                textAlign: 'left',  // Changed to left alignment
                padding: '0 0.5rem'
              }}>
                {vision?.content || 'To become the most trusted partner in digital engineering transformation, empowering organizations worldwide with intelligent simulation and power system expertise.'}
              </p>
            </div>
            
            {/* Mission Card */}
            <div style={{
              background: 'white',
              padding: 'clamp(1.5rem, 5vw, 2.5rem)',
              borderRadius: '24px',
              boxShadow: '0 10px 25px -5px rgba(0,0,0,0.05)',
              border: '1px solid #E2E8F0',
              transition: 'all 0.3s ease',
              height: '100%',
              display: 'flex',
              flexDirection: 'column'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.borderColor = '#2C7A7B';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = '#E2E8F0';
            }}>
              <div style={{
                width: 'clamp(60px, 12vw, 70px)',
                height: 'clamp(60px, 12vw, 70px)',
                background: 'linear-gradient(135deg, #2C7A7B 0%, #4A9D9E 100%)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem auto'
              }}>
                <i className="fas fa-bullseye" style={{ fontSize: 'clamp(1.5rem, 5vw, 2rem)', color: 'white' }}></i>
              </div>
              <h3 style={{ 
                fontSize: 'clamp(1.3rem, 5vw, 1.8rem)', 
                marginBottom: '1rem', 
                color: '#0A192F',
                fontWeight: 700,
                textAlign: 'center'
              }}>
                {mission?.title || 'Our Mission'}
              </h3>
              <div style={{ flex: 1, padding: '0 0.5rem' }}>
                {renderMissionContent(mission?.content)}
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div style={{
            marginTop: 'clamp(2rem, 6vw, 4rem)',
            textAlign: 'center',
            padding: 'clamp(1.5rem, 5vw, 3rem)',
            background: 'linear-gradient(135deg, #0A192F 0%, #1E3A5F 100%)',
            borderRadius: '24px',
            color: 'white'
          }}>
            <h3 style={{ 
              fontSize: 'clamp(1.3rem, 5vw, 1.8rem)', 
              marginBottom: '1rem',
              color: 'white'
            }}>
              10+ Years of Excellence
            </h3>
            <p style={{ 
              fontSize: 'clamp(0.9rem, 3.5vw, 1rem)', 
              color: 'rgba(255,255,255,0.9)',
              maxWidth: '600px',
              margin: '0 auto',
              padding: '0 1rem'
            }}>
              Trusted by 500+ clients across 6 continents, delivering innovative solutions 
              that power the future of engineering.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default DynamicAbout;